import React from "react";
import IconDelete from "../../../../layout/others/icon_delete.svg";
import { useTranslation } from "react-i18next";

export default function DOCOnlineOtherTechSkillItem(props) {
  const { t } = useTranslation();

  function onChange({ target }) {
    props.onChangeData({
      name: target.name,
      value: target.value,
      key: props.techSkill.description
    });
  }

  function OnChangeskillExperienceTime({ target }) {
    props.onChangeData({
      name: target.name,
      value: parseInt(target.value),
      key: props.techSkill.description
    });
  }

  return (
    <div className="row">
      {" "}
      {props.children}
      <div className="col-3">
        {props.withIndex && <strong>{props.techSkill.order}º</strong>}
        {"   "}
        {t(props.techSkill.description)}
      </div>
      <div className="form-group col-2">
        {props.errors?.skillExperienceTimeId && (
          <div className="error-msg">{props.errors.skillExperienceTimeId}</div>
        )}
        <select
          className="form-select"
          value={props.techSkill.skillExperienceTimeId || ""}
          onChange={OnChangeskillExperienceTime}
          name="skillExperienceTimeId"
        >
          <option></option>
          {props.yearsExperience.map((xp) => (
            <option key={xp.id} value={xp.id}>
              {t(xp.description)}{" "}
            </option>
          ))}
        </select>
      </div>
      <div className="col-4">
        {props.errors?.skillLevelId && (
          <div className="error-msg">{props.errors.skillLevelId}</div>
        )}
        <div className="level-buttons">
          {props.skillLevels.map((skillLevel) => (
            <button
              key={skillLevel.Id}
              type="button"
              className={`action-button ${
                props.techSkill &&
                props.techSkill.skillLevelId === skillLevel.id &&
                `bg-dark text-white `
              }`}
              onClick={() =>
                onChange({
                  target: { name: "skillLevelId", value: skillLevel.id }
                })
              }
            >
              {t(skillLevel.description)}
            </button>
          ))}
        </div>{" "}
      </div>{" "}
      <div className="col text-end">
        <button
          className="action-button "
          onClick={props.deleteTechSkill}
          type="button"
        >
          <img
            src={IconDelete}
            alt="ico-notification"
            height="12px"
            width="auto"
          />
        </button>
      </div>
    </div>
  );
}
